import styled from 'styled-components'

export const Container = styled.div`
	form {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-template-areas:
			'faculdade ingresso conclusao declaracao'
			'action_footer action_footer action_footer action_footer';

		@media(max-width: 900px) {
			grid-template-columns: repeat(3, 1fr);
			grid-template-areas:
				'faculdade ingresso conclusao'
				'declaracao x x'
				'action_footer action_footer action_footer';
		}

		@media(max-width: 700px) {
			grid-template-columns: repeat(2, 1fr);
			grid-template-areas:
				'faculdade ingresso'
				'conclusao declaracao'
				'action_footer action_footer';
		}

		@media(max-width: 600px) {
			display: flex;
			flex-direction: column;
		}
	}

	.table-container {
		width: calc(100% - 16px);
		margin: 12px 8px 0;
	}
`
